import React from 'react';

import { getRaces } from '../../data';
import SelectVariants from '../Select';

import { useRace, useRaceUpdate} from '../../contexts/RaceContext';

const SelectRace = ({ withLabel = true, small = false }) => {
  const race = useRace()
  const setRace = useRaceUpdate()

  const races = getRaces();

  const defaultValue = "all";
  const name = "VICTIM";
  const options = races.map((r) => {
    return {
      value: r.toString(),
      label: r.toString().toLowerCase(),
    };
  });

  return (
    <SelectVariants
      withLabel={withLabel}
      small={small}
      name={name}
      field={race}
      setField={setRace}
      options={[{ value: "all", label: "people" }, ...options]}
      defaultValue={defaultValue}
    />
  );
};

export default SelectRace;
